<template>
<div class="flex-row">
  <label :class="['ms-checkbox', {'event-none': readOnly}]">
    <input
      v-show="isHideCheckbox"
      type="checkbox"
      class="ms-checkbox-control"
      :readOnly="readOnly"
      :checked="isChecked"
      :value="isChecked"
      :disabled="isDisableCheckbox"
      v-on="listeners"
    />
    <!-- <span :class="['checkmark', { 'event-none': readOnly }]"></span> -->
    <span v-if="label && isShowLabel" :class="['ms-checkbox--text',disabled ? 'disabled' : ''].join(' ')" :title="title ? title : ''">{{ label }}</span>
  </label>
  </div>
</template>
<script>
import {defineComponent, computed, watch, ref, nextTick} from 'vue';
export default defineComponent({
  name: 'MsCheckbox',
  props: {
    /**
     * lấy dòng dữ liệu
     * NCQUYEN 29/11/2022
     */
    dataRow: {
      default: null,
      type: Object,
    },
    modelValue: {
      default: false,
      type: [Boolean, Number],
    },
    label: {
      default: null,
      type: String,
    },
    disabled: {
      default: false,
      type: [Boolean, Function],
    },
    readOnly: {
      default: false,
      type: Boolean,
    },
    checked: {
      type: [Boolean, Number],
      default: false,
    },
    isShowLabel: {
      // có hiển thị label ko?
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: null,
    },
  },
  setup(props, {emit}) {
    // Variable
    let focused = false;
    const isHideCheckbox = ref(true);
    const isDisableCheckbox = ref(false);
    /**
     * Ẩn checkbox
     * NCQUYEN 29.11.2022
     */
    nextTick(() => {
      if (props.dataRow?.hasOwnProperty('_isHideCheckbox')) {
        if (!props.dataRow._isHideCheckbox) {
          isHideCheckbox.value = props.dataRow._isHideCheckbox;
        } else {
          isHideCheckbox.value = true;
        }
      } else {
        isHideCheckbox.value = true;
      }

      if (props.dataRow?.hasOwnProperty('_isDisabled')) {
        if (props.dataRow._isDisabled) {
          isDisableCheckbox.value = props.dataRow._isDisabled;
        } else {
          isDisableCheckbox.value = props.disabled;
        }
      } else {
        isDisableCheckbox.value = props.disabled;
      }
    });

    /**
     * bắt thay đổi của disabled
     */
    watch(
      () => props.disabled,
      () => {
        isDisableCheckbox.value = props.disabled;
      },
    );
    // Method
    const onFocus = () => {
      focused = true;
    };
    const onBlur = () => {
      focused = false;
    };

    /**
     * Hủy lan rộng event
     * HTHIEP 09.02.2022
     */
    const cancelEvent = e => {
      if (e) {
        if (typeof e.preventDefault === 'function') {
          e.preventDefault();
        }

        if (typeof e.stopPropagation === 'function') {
          e.stopPropagation();
        }

        if (typeof e.stopImmediatePropagation === 'function') {
          e.stopImmediatePropagation();
        }
      }
    };

    // Event
    const listeners = computed(() => {
      return {
        click: event => {
          // emit('click', event);
        },
        input: () => {
          emit('update:modelValue', !props.modelValue);
        },
        change: event => {
          cancelEvent(event);
          emit('change', props.modelValue, props.label);
        },
        focus: event => {
          onFocus(event);
        },
        blur: event => {
          onBlur(event);
        },
      };
    });
    const isChecked = computed(() => props.modelValue || props.checked);

    return {
      focused,
      onFocus,
      onBlur,
      listeners,
      isChecked,
      isHideCheckbox,
      isDisableCheckbox,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '@/assets/scss/components/MsCheckbox.scss';
</style>
